import { render, staticRenderFns } from "./filmproducerInfo.vue?vue&type=template&id=63fb92e4&scoped=true&"
import script from "./filmproducerInfo.vue?vue&type=script&lang=js&"
export * from "./filmproducerInfo.vue?vue&type=script&lang=js&"
import style0 from "./filmproducerInfo.vue?vue&type=style&index=0&id=63fb92e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb92e4",
  null
  
)

export default component.exports